import { LeftOutlined } from '@ant-design/icons'
import {
  Button,
  Flex,
  Timeline,
} from 'antd'
import React from 'react'

import { useFormatTime } from '@/hooks/use-format-time'
import { useAppSelector } from '@/redux/utils'

import styles from '../settings.module.css'

import SalesSettingsDisplay from './components/sales-settings-display'

export interface HistoryProps {
  onBack: () => void
}

export default function History({ onBack }: HistoryProps) {
  const history = useAppSelector((state) => state.salesSettings.history)
  const formatTime = useFormatTime()
  const items = history.map((salesSettings) => ({
    children: (
      <div>
        Start from {formatTime()(salesSettings.effectAt)}
        <SalesSettingsDisplay salesSettings={salesSettings} />
      </div>
    ),
  }))

  return (
    <Flex vertical className={styles.settingsSection}>
      <Flex className="settings-content-header">
        <Button type="text" icon={<LeftOutlined />} onClick={onBack}>
          Back
        </Button>
      </Flex>
      <div className="settings-content">
        <Timeline items={items} />
      </div>
    </Flex>
  )
}
